/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { ReactElement } from 'react';
import { useDevice } from '@userzoomplatform/pe-study-layout';
import { Devices } from '../../utils/constants';
import { BrowserRestrictions, OsRestrictions } from '../../types/restrictions';
import RestrictionCardDesktop from './restriction-card-desktop';
import RestrictionCardMobile from './restriction-card-mobile';

const { Desktop, Mobile, Tablet } = Devices;

type Props = {
	className?: string;
	image: { url: string; alt: string };
	device: typeof Desktop | typeof Mobile | typeof Tablet;
	browsers: BrowserRestrictions[];
	os: OsRestrictions[];
};

const defaultProps = {
	className: '',
};

const RestrictionCard = ({ className, image, device: deviceInfoToShow, browsers = [], os = [] }: Props): ReactElement => {
	const { device } = useDevice();
	return (
		<div className={`${className} is-${device?.type}`}>
			<img className="device-image" src={image.url} alt={image.alt} />
			{deviceInfoToShow === Desktop ? (
				<RestrictionCardDesktop browsers={browsers} />
			) : (
				<RestrictionCardMobile device={deviceInfoToShow} os={os} />
			)}
		</div>
	);
};

RestrictionCard.defaultProps = defaultProps;

export default RestrictionCard;
